export default class EmployeePositionModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
			this.name = data.name ?? '';
			this.description = data.description;
			this.hourlySalary = data.hourlySalary ?? 0;  
		}
	}

	id = 0;
	name = '';
	description: string | null = null;
	hourlySalary = 0;
}